angular.module( 'acme.view.application.passes.create.series', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.create.series.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesCreateSeries = {
        name: 'application.passes.create.series',
        url: '/series',
        views: {
          "subview-main": {
            controller: 'PassesCreateSeriesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/series/series.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Pass Program Series'
        }
      },
      passesEditSeries = {
        name: 'application.passes.edit.series',
        url: '/series',
        views: {
          "subview-main": {
            controller: 'PassesCreateSeriesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/series/series.tpl.html'
          }
        },
        data: {
          pageTitle: 'Edit Pass Program Series'
        }
      };

    $stateProvider
      .state(passesCreateSeries)
      .state(passesEditSeries);
});
